import { Route, Routes } from "react-router-dom";
import { observer } from "mobx-react-lite";
import EmailVerification from "../pages/EmailVerification/EmailVerification";
import Main from "../pages/Main/Main";
import AdminPanel from "../pages/Admin/AdminPanel";
import useUser from "../hooks/useUser";
import NotFound from "./NotFound/NotFound";
import Profile from "../pages/Profile/Profile";
import Gallery from "../pages/Gallery/Gallery";
import Biography from "../pages/Biography/Biography";
import Event from "../pages/Event/Event";
import Poster from "../pages/Poster/Poster";
import Agreement from "../pages/Agreement/Agreement";
import UpdateProfile from "../pages/Profile/UpdateProfile";
import Contacts from "../pages/Contacts/Contacts";
import Tour from "../pages/Tour/Tour";
import PrivacyPolicy from "../pages/Agreement/PrivacyPolicy";
import PublicOffer from "../pages/Agreement/PublicOffer";
import RegPage from "../pages/RegPage/RegPage";

const publicRoutes = [
    { path: '*', Component: NotFound },
    { path: '/', Component: Main },
    { path: '/verify-email', Component: EmailVerification },
    { path: '/events', Component: Poster },
    { path: '/gallery', Component: Gallery },
    { path: '/biography', Component: Biography },
    { path: '/user-agreement', Component: Agreement },
    { path: '/event/:eventId/:dateId', Component: Event },
    { path: '/tour', Component: Tour },
    { path: '/contacts', Component: Contacts },
    { path: '/privacy-policy', Component: PrivacyPolicy },
    { path: '/public-offer', Component: PublicOffer },
    { path: '/reg', Component: RegPage }
];

const authRoutes = [
    { path: '/profile', Component: Profile },
    { path: '/updateProfile', Component: UpdateProfile },
];

const adminRoutes = [
    { path: '/admin-panel', Component: AdminPanel },
];


const AppRouter = observer(() => {
    const user = useUser();
    
    return (
        <Routes>
            {publicRoutes.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}
            
            {user?.isAuth && authRoutes.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}
            
            {user.isAdmin && adminRoutes.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}
        </Routes>
    )
})

export default AppRouter